export const ACH_METHOD = "BANK_ACCOUNT";
export const CC_METHOD = "CREDIT_CARD";
export const CASH_METHOD = "CASH";
